import React, { useState, useEffect } from "react";
import Chart from "react-google-charts";
import { Maximize32 } from '@carbon/icons-react';
import AnchorLink from 'react-anchor-link-smooth-scroll';
import moment from 'moment';

import DashboardSummary from '../DashboardSummaryNew';
import * as DashboardUtils from '../DashboardUtils.js';
import callPostApi from 'requests/PostRequests';
import * as Constants from '../../../requests/URLConstants';
import * as DashboardConstants from '../DashboardConstants';
import TableToolbarDownload from "../../../common/TableToolbarDownload";
import { GeoTableHeaders, GeoTableData, UsageTableData, UsageTableHeaders } from './tableHeaders';
import TableWithExpandedRowList from 'common/TableWithExpandedRowList';
import { locationList, locationNameList } from './LocationConfig';
import * as workspaces from '../../../config/WorkspaceConstants';
import * as data from './MockData.json';
require("./_usage.scss");

const UsageStats = (props) => {
    const [UsageTableLoading, setUsageTableLoading] = useState(true);
    const [SummaryData, setSummaryData] = useState([]);
    const [showUserData, setShowUserData] = useState(false);
    const [selectedCountry, setSelectedCountry] = useState('');
    const [GeoData, setGeoData] = useState(GeoTableData); //onclick event
    const [geoMapData, setGeoMapData] = useState([]);
    const [geoTableData, setGeoTableData] = useState([]);
    const [userActivityData, setUserActivityData] = useState([]);

    useEffect(() => {
        UsageSummary();
    }, []);

    useEffect(() => {
        getUsageStatsDetails(props.timeFilterSelections, props.filterSelectionsAutomation, props.filterSelectionsSAP, props.workspace);
    }, [props.preferencesChanged]);

    const UsageSummary = (totalUsers, totalSessions, AverageDuration) => {
        let summary = [
            {
                title: DashboardConstants.TotalUniqueVisitors,
                value: totalUsers ? totalUsers : 0,
            },
            {
                title: DashboardConstants.TotalSessions,
                value: totalSessions ? totalSessions : 0,
            },
            {
                title: DashboardConstants.AverageDuration,
                value: AverageDuration ? AverageDuration : 0,
            },
        ];
        setSummaryData(summary);
    };


    var options = {
        colors: ["#00539a"],
        colorAxis: { colors: ["#1192e8", "#0072C3", "#00539a"] },
        backgroundColor: { fill: "white" },
        legend: { orientation: "horizontal" },
        resolution: 'subcontinents',
        tooltip: { isHtml: true, trigger: "visible" }
    };

    // function toggleFullScreen() {
    //     if (!document.getElementById('reactgooglegraph-1').fullscreenElement) {
    //         document.getElementById('reactgooglegraph-1').requestFullscreen();
    //         document.getElementById('reactgooglegraph-1').style.background = "white"
    //     } else {
    //         if (document.getElementById('reactgooglegraph-1').exitFullscreen) {
    //             document.getElementById('reactgooglegraph-1').exitFullscreen();
    //         }
    //     }
    // }

    // function handleCountryClick(){
    //     props.handleCountryClick(selectedCountry);
    // }

    const getPayload = (timeFilterSelections, dashboardFilterSelectionsAutomation, dashboardFilterSelectionsSAP, workspace) => {
        let calenderInterval = DashboardUtils.getCalenderInterval(timeFilterSelections);
        let timeZone = moment.tz.guess();
        let technology;
        let franchise;
        let client;
        let bodyJSON;

        if (workspace === workspaces.automation_ops) {
            technology = dashboardFilterSelectionsAutomation.technology;
            franchise = dashboardFilterSelectionsAutomation.franchise;
            client = dashboardFilterSelectionsAutomation.client;
            bodyJSON = {
                "filters": {
                    "time": {
                        "startDateTime": timeFilterSelections.startDateTime,
                        "endDateTime": timeFilterSelections.endDateTime
                    },
                    "franchises": franchise,
                    "clients": client,
                    "technologies": technology,
                    "deployment_models": dashboardFilterSelectionsAutomation.deployment_model,
                    "geos": dashboardFilterSelectionsAutomation.geo,
                    "business_competencies": dashboardFilterSelectionsAutomation.competency,
                    "status": dashboardFilterSelectionsAutomation.status,
                    "automata_priority": dashboardFilterSelectionsAutomation.priority,
                    "automata_state": dashboardFilterSelectionsAutomation.automata_state,
                    "automata_name": dashboardFilterSelectionsAutomation.automata_activity_name,
                    "resource": dashboardFilterSelectionsAutomation.resource,
                    "bot_id": dashboardFilterSelectionsAutomation.bot_id
                },
                "interval": {
                    "calender_Interval": calenderInterval,
                    "time_zone": timeZone
                },
                "workspace": workspace
            };
        }
        return bodyJSON;
    };

    function prepareGeoUserLoggedInDetails(resp) {
        let geoBuckets = resp.aggregations["Geo"].buckets;
        let data = [
            [
                'Country',
                'Unique Visitors',
                { role: "tooltip", type: "string", p: { html: true } }
            ]
        ];
        let count = 0;
        for (let i = 0; i < geoBuckets.length; i++) {
            let usersCount = geoBuckets[i]['User Name'].buckets.length;
            locationList.map((item) => {
                if (geoBuckets[i].key === '["DO_Test"]') {
                    let indiaKey = 'DO_Test';
                    if (Object.hasOwn(item, indiaKey)) {
                        data.map((dataItem) => {
                            if (count === 0) {
                                data.push([item[indiaKey], usersCount, `<div><b>Southern Asia</b><br/>${DashboardConstants.UniqueVisitors}: ${usersCount}</div>`]);
                                count = count + 1;
                            }
                            else {
                                if (dataItem[0] === '034') {
                                    dataItem[1] = dataItem[1] + usersCount;
                                    dataItem[2] = `<div><b>Southern Asia</b><br/>${DashboardConstants.UniqueVisitors}:${dataItem[1]}</div>`
                                }
                            }
                        })

                    }
                }
                else {
                    let text = geoBuckets[i].key.substring(2);
                    text = text.slice(0, -2)
                    console.log(text);
                    if (Object.hasOwn(item, text)) {
                        locationNameList.map((locationItem) => {
                            if (Object.hasOwn(locationItem, text)) {
                                data.push([item[text], usersCount, `<div><b>${locationItem[text]}</b><br/>${DashboardConstants.UniqueVisitors}: ${usersCount}</div>`])
                            }
                        })

                    }
                    else {
                        data.map((dataItem) => {
                            if (count === 0) {
                                count = count + 1;
                                data.push(['034', usersCount, `<div><b>Southern Asia</b><br/>${DashboardConstants.UniqueVisitors}: ${usersCount}</div>`]);
                            }
                            else {
                                if (dataItem[0] === '034') {
                                    dataItem[1] = dataItem[1] + usersCount;
                                    dataItem[2] = `<div><b>Southern Asia</b><br/>${DashboardConstants.UniqueVisitors}:${dataItem[1]}</div>`
                                }
                            }
                        })
                    }

                }
            });
        }
        setGeoMapData(data);
    }

    function prepareUserLoggedInTableDetails(resp) {
        let tableData = [], userLoggedInData = [];
        let tableObj = {}, userLoggedInDataObj = {};
        let geoBuckets = resp.aggregations["Geo"].buckets;
        let totalUsers = 0, TotalDuration = 0, totalSessions = 0;
        let count = 0;
        for (let i = 0; i < geoBuckets.length; i++) {
            for (let j = 0; j < locationNameList.length; j++) {
                let usersCount = geoBuckets[i]['User Name'].buckets.length;
                //Calculate total unique visitors
                totalUsers = totalUsers + usersCount;

                if (geoBuckets[i].key === '["DO_Test"]') {
                    let indiaKey = 'DO_Test';
                    if (Object.hasOwn(locationNameList[j], indiaKey)) {
                        console.log(true);
                        if (count === 0) {
                            tableObj = {
                                id: i + 1,
                                geos: locationNameList[j][indiaKey],
                                unique_users: usersCount
                            }
                            count = count = 1;
                            tableData.push(tableObj);
                        }
                        else {
                            tableData.map((tableItem) => {
                                if (tableItem.geos === 'Southern Asia') {
                                    tableItem.unique_users = tableItem.unique_users + usersCount;
                                }
                            })
                        }
                    }
                }
                else {
                    let text = geoBuckets[i].key.substring(2);
                    text = text.slice(0, -2)
                    console.log(text);
                    if (Object.hasOwn(locationNameList[j], text)) {
                        tableObj = {
                            id: i + 1,
                            geos: locationNameList[j][text],
                            unique_users: usersCount
                        }
                        tableData.push(tableObj);
                    }
                    else {
                        console.log(tableData, "table");
                        if (count === 0) {
                            tableObj = {
                                id: i + 1,
                                geos: 'Southern Asia',
                                unique_users: usersCount
                            }
                            count = count + 1;
                            tableData.push(tableObj);
                        }
                        else {
                            tableData.map((tableItem) => {
                                if (tableItem.geos === 'Southern Asia') {
                                    tableItem.unique_users = tableItem.unique_users + usersCount;
                                }
                            })
                        }
                    }
                }
                let usersBucket = geoBuckets[i]['User Name'].buckets;
                for (let k = 0; k < usersBucket.length; k++) {
                    let sessionsBuckets = usersBucket[k]['ID'].buckets;
                    totalSessions = totalSessions + sessionsBuckets.length;
                    for (let l = 0; l < sessionsBuckets.length; l++) {
                        //let userName = usersBucket[k].key.substring(0, usersBucket[k].key.indexOf("@"));
                        let transactionBuckets = sessionsBuckets[l]['Transaction Name'].buckets;
                        let loggedinDt = '', loggedOutDt = '', resolvedDuration = '', loggedOutTime = '', loggedInTime = '', lastActivityDateArr = '';
                        for (let m = 0; m < transactionBuckets.length; m++) {
                            let LKey = transactionBuckets[m].key;
                            if (transactionBuckets.length > 1) {
                                if (LKey.includes('login')) {
                                    //login Calculation
                                    loggedInTime = transactionBuckets[m]['Time'].value_as_string;
                                    let fLoggedInDate = moment(loggedInTime).format("Do MMM");
                                    let fLoggedInTime = moment(loggedInTime).format("h:mm a");
                                    loggedinDt = `${fLoggedInDate}|${fLoggedInTime}`;
                                }

                                if (LKey.includes('logout')) {
                                    //Logout calculation
                                    loggedOutTime = transactionBuckets[m]['Time'].value_as_string;
                                    let fLoggedOutDate = moment(loggedOutTime).format("Do MMM");
                                    let fLoggedOutTime = moment(loggedOutTime).format("h:mm a");
                                    loggedOutDt = `${fLoggedOutDate}|${fLoggedOutTime}`;
                                }
                                //Duration Calculation
                                if (loggedOutTime !== '' && loggedInTime !== '') {
                                    let resolvedSecs = moment(new Date(loggedOutTime)).diff(moment(new Date(loggedInTime)), 'seconds');
                                    let resolvedMins = moment(new Date(loggedOutTime)).diff(moment(new Date(loggedInTime)), 'minutes');
                                    let resolvedHours = moment(new Date(loggedOutTime)).diff(moment(new Date(loggedInTime)), 'hours');
                                    let resolvedDays = moment(new Date(loggedOutTime)).diff(moment(new Date(loggedInTime)), 'days');

                                    if (resolvedSecs >= 0 && resolvedSecs < 60) {
                                        resolvedDuration = resolvedSecs !== 1 ? `${resolvedSecs} secs` : `${resolvedSecs} sec`
                                    }
                                    else if (resolvedSecs >= 60 && resolvedSecs < 3600) {
                                        resolvedDuration = resolvedMins !== 1 ? `${resolvedMins} mins` : `${resolvedMins} min`
                                    }
                                    else if (resolvedSecs >= 3600 && resolvedSecs < 86400) {
                                        resolvedDuration = resolvedHours !== 1 ? `${resolvedHours} hours` : `${resolvedHours} hour`
                                    }
                                    else if (resolvedSecs >= 86400 && resolvedHours >= 24) {
                                        resolvedDuration = resolvedDays !== 1 ? `${resolvedDays} days` : `${resolvedDays} day`
                                    }
                                    // else {
                                    //     resolvedDuration = `${0} min`
                                    // }
                                    //Total Duration calculation
                                    TotalDuration = TotalDuration + resolvedMins;
                                    //Activity calculation
                                    lastActivityDateArr = moment(new Date(loggedInTime)).from(moment(new Date(loggedOutTime)));

                                }
                            }
                            else {
                                //If there is no Logout time(currently active)

                                loggedInTime = transactionBuckets[m]['Time'].value_as_string;
                                let fLoggedInDate = moment(loggedInTime).format("Do MMM");
                                let fLoggedInTime = moment(loggedInTime).format("h:mm a");
                                loggedinDt = `${fLoggedInDate}|${fLoggedInTime}`;

                                loggedOutDt = '-'

                                let resolvedSecs = moment(new Date()).diff(moment(new Date(loggedInTime)), 'seconds');
                                let resolvedMins = moment(new Date()).diff(moment(new Date(loggedInTime)), 'minutes');
                                let resolvedHours = moment(new Date()).diff(moment(new Date(loggedInTime)), 'hours');
                                let resolvedDays = moment(new Date()).diff(moment(new Date(loggedInTime)), 'days');

                                if (resolvedSecs >= 0 && resolvedSecs < 60) {
                                    resolvedDuration = resolvedSecs !== 1 ? `${resolvedSecs} secs` : `${resolvedSecs} sec`
                                }
                                else if (resolvedSecs >= 60 && resolvedSecs < 3600) {
                                    resolvedDuration = resolvedMins !== 1 ? `${resolvedMins} mins` : `${resolvedMins} min`
                                }
                                else if (resolvedSecs >= 3600 && resolvedSecs < 86400) {
                                    resolvedDuration = resolvedHours !== 1 ? `${resolvedHours} hours` : `${resolvedHours} hour`
                                }
                                else if (resolvedSecs >= 86400 && resolvedHours >= 24) {
                                    resolvedDuration = resolvedDays !== 1 ? `${resolvedDays} days` : `${resolvedDays} day`
                                }
                                // else {
                                //     resolvedDuration = `${0} min`
                                // }
                                //Total Duration calculation
                                TotalDuration = TotalDuration + resolvedMins;

                                lastActivityDateArr = 'currently active';
                            }
                            userLoggedInDataObj = {
                                username: usersBucket[k].key,
                                logged_in_at: loggedinDt,
                                logged_out_at: loggedOutDt,
                                duration: resolvedDuration,
                                activity: lastActivityDateArr
                            }
                        }
                        userLoggedInData.push(userLoggedInDataObj);
                    }

                }

            }

        }
        let AverageDuration = (TotalDuration / totalSessions);
        UsageSummary(totalUsers, totalSessions, AverageDuration);
        setGeoTableData(tableData);
        setUserActivityData(userLoggedInData);
    }


    function getUsageStatsDetails(timeFilterSelections, dashboardFilterSelectionsAutomation, dashboardFilterSelectionsSAP, workspace) {
        if (timeFilterSelections && workspace && (dashboardFilterSelectionsAutomation || dashboardFilterSelectionsSAP)) {
            let bodyJSON = getPayload(timeFilterSelections, dashboardFilterSelectionsAutomation, dashboardFilterSelectionsSAP, workspace);
            callPostApi(Constants.GETUSAGESTATSDETAILS, {
                'Content-Type': 'application/json'
            }, bodyJSON)
                .then(resp => {
                    prepareGeoUserLoggedInDetails(resp);
                    prepareUserLoggedInTableDetails(resp);
                    setUsageTableLoading(false);
                }).catch((error) => {
                    setUsageTableLoading(false);
                });
        }
    };

    function handleCountryClick(region) {
        setSelectedCountry(region);
    }

    // const chartEvents = [
    //     {
    //         eventName: "select",
    //         callback({ chartWrapper, google }) {
    //             var chart = chartWrapper.getChart();
    //             google.visualization.events.addListener(chartWrapper.getChart(), 'select', function (e) {
    //                 var data = chartWrapper.getDataTable();
    //                 var selection = chart.getSelection();
    //                 if (selection.length > 0) {
    //                     var nodeName = selection[0].row;
    //                     console.log(nodeName);
    //                     let countryName = data.getFormattedValue(nodeName, 0);
    //                     GeoData.map((items) => {
    //                         if (items.geos === countryName)
    //                             items.isExpand = true
    //                         else
    //                             items.isExpand = false
    //                     })
    //                     setGeoData(GeoData);
    //                     setSelectedCountry(countryName);
    //                     setShowUserData(true);
    //                 }
    //                 //else
    //                 //setSelectedCountry('');
    //                 // else
    //                 // setShowUserData(false);
    //             });
    //         }
    //     },
    // ];
    return (
        <div className="top-margin dashboard usage-dashboard">
            <div className="dashboard-detail-container col-lg-12 no-gutters">
                <div className="dashboard-roleContainer col-lg-12">
                    <DashboardSummary loading={UsageTableLoading} summary={SummaryData} title={DashboardConstants.UsageStats} />
                </div>
                <div className="dashboard-charts-container">
                    <section>
                        <div className="graph-title carbon-display-Regular-20">{DashboardConstants.GeoHeatmap}</div>
                        {/* <div className="buttons">
                            <div className="fullScreen-button">
                                <button><Maximize32 onClick={() => toggleFullScreen()} /></button>
                            </div>
                        </div> */}
                        <Chart
                            className="GeoChart"
                            id="GeoChart"
                            chartType="GeoChart"
                            width="90%"
                            height="90%"
                            data={geoMapData}
                            options={options}
                        // chartEvents={chartEvents}
                        />
                    </section>
                    <section className="usageStats-content">
                        <div>
                            <div className="graph-title carbon-display-Regular-20" style={{ display: 'flex', justifyContent: 'flex-end' }}>
                                <div className="download-button">
                                    <TableToolbarDownload iconDescription={DashboardConstants.Export} rows={geoTableData} headers={GeoTableHeaders} title={DashboardConstants.RobotTerminationTrend} filename={DashboardConstants.Export} label={DashboardConstants.Download} />
                                </div>
                            </div>
                            <div className="usage-statsTable">
                                <TableWithExpandedRowList
                                    // rows={showUserData ? GeoData : GeoTableData}
                                    rows={geoTableData}
                                    headers={GeoTableHeaders}
                                    title={""}
                                    expandedRowList={userActivityData}
                                    expandedRowHeaders={UsageTableHeaders}
                                    showPagination={true}
                                    country={selectedCountry}
                                    userData={showUserData}
                                    isExpandable={true}
                                    isSortable={true}
                                    handleCountryClick={handleCountryClick}
                                />
                            </div>
                        </div>
                    </section>
                </div>
            </div>
        </div >
    );
};

export default UsageStats;
